import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import {Container, Nav} from "react-bootstrap";

export default class BootstrapNavbar extends React.Component {
    render() {
        return(
            <>
                <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                    <Container>
                        <Navbar.Brand href="/">Gooseworks</Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link href='/'>home</Nav.Link>
                                <Nav.Link target="_blank" href="https://uptime.gooseworks.net/">status</Nav.Link>
                                <Nav.Link target="_blank" href="https://www.as401441.net/">network</Nav.Link>
                                <Nav.Link href='/about'>about</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </>
        )
    }
}